import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";

export default function DetailsView({
  groupedDebts,
  goBack,
}: PropsView) {
  return (
    <div className="relative flex flex-1 flex-col w-full">
      <Header 
        title="Detalhes"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-1 z-10 p-2 w-full flex justify-center h-full text-black h-form">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div className="w-full">
            <h2 className="font-bold text-xl mb-2 mt-2">{groupedDebts?.owner}</h2>
            {groupedDebts?.debts?.map((item, index) => (
                <div key={index}>
                  <div className="flex items-center w-full p-1">
                    <div className="w-full">
                      <p className="text-base">{item?.original?.nmPraca}</p>
                      <div className="flex justify-between w-full">
                        <p className="text-base">{item?.date}{item?.hour !== "00:00:00" ? ` - ${item?.hour}` : ""}</p>
                        <p className="text-base font-bold">R$ {item?.price}</p>
                      </div>
                    </div>
                  </div>
                  <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
                </div>
              ))}
          </div>
          <div>
            <div className="border-1 border border-gray-400 w-full p-4 rounded-lg flex items-center mb-5">
              <img 
                src={"/icon-square.png"}
                width={40}
                height={40}
                alt="Informação"
                className="h-[calc(40px)] w-[calc(40px)]"
              />
              <p className="ml-2 text-gray-600 text-sm">Podem existir algumas passagens que ainda não foram recebidas e não foram listadas aqui.</p>
            </div>
            <button className="mb-6 bg-black border p-2 rounded-lg h-[calc(60px)] text-white w-full hover:bg-transparent hover:text-black" type="submit" onClick={goBack}>Voltar</button>
          </div>
        </article>
      </main>
    </div>
  );
}
